<template>
  <v-btn
    v-bind="$attrs"
    v-on="$listeners"
    :icon="icon"
    :aria-label="ariaLabel"
    class="icon-button"
  >
    <v-icon>{{ buttonIcon }}</v-icon>
  </v-btn>
</template>

<script>
export default {
  name: 'AdsIconButton',
  props: {
    ariaLabel: {
      type: String,
      default: ''
    },
    buttonIcon: {
      type: String,
      default: null
    },
    icon: {
      type: Boolean,
      default: true   // override the default value 'false' in v-btn
    },
  }
};
</script>

<style lang='scss' scoped>
@import "../../styles/variables.scss";

.theme--dark {
  .icon-button {
    &:focus {
      border: 3px solid !important;
      outline: 1px solid transparent !important;
    }
  }
}

.icon-button {
  &:focus {
    border: 3px solid $ads-navy !important;
    outline: 1px solid transparent !important;
  }
}

// v-btn a11y focus state updates
.theme--light.v-btn:not(.v-btn--text):not(.v-btn--outlined):focus:before,
.theme--light.v-btn:focus::before,
.theme--dark.v-btn:focus::before {
  opacity: 0;
}

.theme--light.v-btn.primary:not(.v-btn--text):not(.v-btn--outlined) {
  border: 3px solid transparent;
}

.theme--light.v-btn.primary:not(.v-btn--text):not(.v-btn--outlined):focus {
  border: 3px solid $ads-info-blue !important;
}

.theme--light.v-btn.v-btn--outlined:focus {
  box-shadow: 0 0 0 4px $ads-navy !important;
}

.theme--light.v-btn.no-outline,
.theme--light.v-btn.v-btn--text {
  border: 2px solid transparent;
}

.theme--light.v-btn.no-outline:focus,
.theme--light.v-btn.v-btn--text:focus {
  border: 2px solid $ads-navy !important;
}

.theme--dark.v-btn.primary:not(.v-btn--text):not(.v-btn--outlined) {
  border: 3px solid transparent;
}

.theme--dark.v-btn.primary:not(.v-btn--text):not(.v-btn--outlined):focus {
  border: 3px solid $ads-white !important;
}

.theme--dark.v-btn.v-btn--outlined:focus {
  box-shadow: 0 0 0 4px $ads-white !important;
  background-color: $ads-navy-dark;
  color: $ads-white !important;
}

.theme--dark.v-btn.no-outline,
.theme--dark.v-btn.v-btn--text {
  border: 2px solid transparent;
}

.theme--dark.v-btn.no-outline:focus,
.theme--dark.v-btn.v-btn--text:focus {
  border: 2px solid $ads-navy-dark !important;
}

.v-btn.v-btn--outlined {
  border-width: 2px;
}
</style>
